import { render, staticRenderFns } from "./DairyEdit.vue?vue&type=template&id=2b4c773e&scoped=true&"
import script from "./DairyEdit.vue?vue&type=script&lang=js&"
export * from "./DairyEdit.vue?vue&type=script&lang=js&"
import style0 from "./DairyEdit.vue?vue&type=style&index=0&id=2b4c773e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c773e",
  null
  
)

export default component.exports